/** Inline SVGs for Plotly modebar (image href icons are unreliable in dynamic SVG). */



export const MODEBAR_ICON_EXPAND_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none"><path d="M10 2H14V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M6 14H2V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M14.0007 2L9.33398 6.66667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M2 14.0007L6.66667 9.33398" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>`;



export const MODEBAR_ICON_CSV_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 19" fill="none"><path d="M1.5 14.875C1.5 15.9062 2.17313 16.75 3 16.75C3.18098 16.7459 3.35925 16.7051 3.52396 16.63C3.68867 16.5549 3.83638 16.4471 3.95813 16.3131C4.0963 16.1724 4.28436 16.0917 4.48157 16.0887C4.67878 16.0856 4.86926 16.1603 5.01178 16.2966C5.15429 16.433 5.23736 16.62 5.24299 16.8171C5.24862 17.0143 5.17637 17.2057 5.04187 17.35C4.78073 17.6311 4.46492 17.8559 4.11381 18.0107C3.7627 18.1655 3.38369 18.2469 3 18.25C1.34531 18.25 0 16.7359 0 14.875C0 13.0141 1.34531 11.5 3 11.5C3.38369 11.5031 3.7627 11.5845 4.11381 11.7393C4.46492 11.8941 4.78073 12.1189 5.04187 12.4C5.17637 12.5443 5.24862 12.7357 5.24299 12.9329C5.23736 13.13 5.15429 13.317 5.01178 13.4533C4.86926 13.5897 4.67878 13.6644 4.48157 13.6613C4.28436 13.6583 4.0963 13.5776 3.95813 13.4369C3.83638 13.3029 3.68867 13.1951 3.52396 13.12C3.35925 13.0449 3.18098 13.0041 3 13C2.17313 13 1.5 13.8437 1.5 14.875ZM8.9625 14.0603C8.5875 13.9516 8.19938 13.84 7.98281 13.7003C7.86563 13.6244 7.8675 13.6066 7.87781 13.5222C7.87945 13.4541 7.89731 13.3873 7.92992 13.3275C7.96253 13.2676 8.00895 13.2164 8.06531 13.1781C8.49656 12.8856 9.50344 13.0159 9.92344 13.1256C10.1159 13.1772 10.3209 13.1502 10.4935 13.0506C10.6661 12.951 10.792 12.787 10.8436 12.5945C10.8952 12.4021 10.8682 12.197 10.7686 12.0245C10.669 11.8519 10.5049 11.726 10.3125 11.6744C10.1138 11.6228 8.34375 11.185 7.23375 11.9331C6.99902 12.0907 6.80178 12.2979 6.65597 12.5401C6.51017 12.7822 6.41937 13.0535 6.39 13.3347C6.2025 14.8234 7.66969 15.2481 8.54625 15.5012C9.67688 15.8284 9.77625 15.9625 9.74438 16.2128C9.71531 16.4387 9.62625 16.5259 9.54375 16.5812C9.1125 16.8681 8.12156 16.7275 7.71094 16.615C7.51899 16.5614 7.31361 16.5863 7.14 16.6841C6.96638 16.782 6.83874 16.9448 6.78516 17.1367C6.73157 17.3287 6.75644 17.534 6.85428 17.7077C6.95212 17.8813 7.11492 18.0089 7.30688 18.0625C7.77186 18.1843 8.25028 18.2473 8.73094 18.25C9.27656 18.25 9.88406 18.1562 10.3706 17.8319C10.6108 17.6723 10.8126 17.4615 10.9616 17.2146C11.1105 16.9677 11.203 16.6909 11.2322 16.4041C11.4375 14.7812 9.88969 14.3284 8.9625 14.0603ZM16.7522 11.5441C16.6594 11.5109 16.561 11.4962 16.4626 11.5011C16.3642 11.5059 16.2677 11.5301 16.1786 11.5722C16.0896 11.6144 16.0097 11.6736 15.9435 11.7467C15.8774 11.8197 15.8263 11.905 15.7931 11.9978L14.625 15.2697L13.4559 11.9978C13.3891 11.8105 13.2505 11.6574 13.0707 11.5722C12.8909 11.487 12.6847 11.4767 12.4973 11.5436C12.31 11.6105 12.1569 11.749 12.0717 11.9288C11.9865 12.1086 11.9762 12.3148 12.0431 12.5022L13.9181 17.7522C13.9701 17.8979 14.0659 18.024 14.1924 18.1132C14.3188 18.2024 14.4698 18.2502 14.6245 18.2502C14.7793 18.2502 14.9302 18.2024 15.0567 18.1132C15.1832 18.024 15.279 17.8979 15.3309 17.7522L17.2059 12.5022C17.2727 12.315 17.2624 12.1089 17.1774 11.9292C17.0923 11.7496 16.9394 11.611 16.7522 11.5441ZM17.25 6.25V8.5C17.25 8.69891 17.171 8.88968 17.0303 9.03033C16.8897 9.17098 16.6989 9.25 16.5 9.25C16.3011 9.25 16.1103 9.17098 15.9697 9.03033C15.829 8.88968 15.75 8.69891 15.75 8.5V7H11.25C11.0511 7 10.8603 6.92098 10.7197 6.78033C10.579 6.63968 10.5 6.44891 10.5 6.25V1.75H2.25V8.5C2.25 8.69891 2.17098 8.88968 2.03033 9.03033C1.88968 9.17098 1.69891 9.25 1.5 9.25C1.30109 9.25 1.11032 9.17098 0.96967 9.03033C0.829018 8.88968 0.75 8.69891 0.75 8.5V1.75C0.75 1.35218 0.908035 0.970644 1.18934 0.68934C1.47064 0.408035 1.85218 0.25 2.25 0.25H11.25C11.3485 0.249923 11.4461 0.269257 11.5371 0.306898C11.6282 0.344539 11.7109 0.399749 11.7806 0.469375L17.0306 5.71937C17.1003 5.78908 17.1555 5.87182 17.1931 5.96286C17.2307 6.05391 17.2501 6.15148 17.25 6.25ZM14.6897 5.5L12 2.81031V5.5H14.6897Z" fill="currentColor"/></svg>`;



export const MODEBAR_ICON_CAMERA_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 18" fill="none"><path d="M17.5 2.25H14.9012L13.6234 0.33375C13.555 0.231142 13.4623 0.147003 13.3535 0.0887865C13.2448 0.0305702 13.1233 0.0000740671 13 0H7C6.87665 0.0000740671 6.75522 0.0305702 6.64648 0.0887865C6.53773 0.147003 6.44502 0.231142 6.37656 0.33375L5.09781 2.25H2.5C1.90326 2.25 1.33097 2.48705 0.90901 2.90901C0.487053 3.33097 0.25 3.90326 0.25 4.5V15C0.25 15.5967 0.487053 16.169 0.90901 16.591C1.33097 17.0129 1.90326 17.25 2.5 17.25H17.5C18.0967 17.25 18.669 17.0129 19.091 16.591C19.5129 16.169 19.75 15.5967 19.75 15V4.5C19.75 3.90326 19.5129 3.33097 19.091 2.90901C18.669 2.48705 18.0967 2.25 17.5 2.25ZM18.25 15C18.25 15.1989 18.171 15.3897 18.0303 15.5303C17.8897 15.671 17.6989 15.75 17.5 15.75H2.5C2.30109 15.75 2.11032 15.671 1.96967 15.5303C1.82902 15.3897 1.75 15.1989 1.75 15V4.5C1.75 4.30109 1.82902 4.11032 1.96967 3.96967C2.11032 3.82902 2.30109 3.75 2.5 3.75H5.5C5.62351 3.75008 5.74512 3.71966 5.85405 3.66143C5.96297 3.60321 6.05583 3.51899 6.12438 3.41625L7.40125 1.5H12.5978L13.8756 3.41625C13.9442 3.51899 14.037 3.60321 14.146 3.66143C14.2549 3.71966 14.3765 3.75008 14.5 3.75H17.5C17.6989 3.75 17.8897 3.82902 18.0303 3.96967C18.171 4.11032 18.25 4.30109 18.25 4.5V15ZM10 5.25C9.18415 5.25 8.38663 5.49193 7.70827 5.94519C7.02992 6.39845 6.50121 7.04269 6.189 7.79643C5.87679 8.55018 5.7951 9.37958 5.95426 10.1797C6.11343 10.9799 6.50629 11.7149 7.08318 12.2918C7.66008 12.8687 8.39508 13.2616 9.19525 13.4207C9.99542 13.5799 10.8248 13.4982 11.5786 13.186C12.3323 12.8738 12.9766 12.3451 13.4298 11.6667C13.8831 10.9884 14.125 10.1908 14.125 9.375C14.1238 8.28136 13.6888 7.23287 12.9154 6.45955C12.1421 5.68624 11.0936 5.25124 10 5.25ZM10 12C9.48082 12 8.97331 11.846 8.54163 11.5576C8.10995 11.2692 7.7735 10.8592 7.57482 10.3795C7.37614 9.89989 7.32415 9.37209 7.42544 8.86289C7.52672 8.35369 7.77673 7.88596 8.14384 7.51884C8.51096 7.15173 8.97869 6.90172 9.48789 6.80044C9.99709 6.69915 10.5249 6.75114 11.0045 6.94982C11.4842 7.1485 11.8942 7.48495 12.1826 7.91663C12.471 8.34831 12.625 8.85582 12.625 9.375C12.625 10.0712 12.3484 10.7389 11.8562 11.2312C11.3639 11.7234 10.6962 12 10 12Z" fill="currentColor"/></svg>`;



/** Same removals as CceData / ChartsDataNew — keep zoomIn2d, zoomOut2d, autoScale2d. */

const MODEBAR_BUTTONS_TO_REMOVE = [

  "lasso2d",

  "select2d",

  "pan2d",

  "resetscale",

  "zoom",

  "toImage",

];



/**

 * QAQC / dashboard modebar: Expand (optional), CSV, PNG.

 * Uses modeBarButtonsToAdd (Plotly 2.x) — custom-only modeBarButtons does not render reliably.

 */

export function buildPlotlyModebarConfig(handlers = {}) {

  const { onExpand, onCsv, onPng, includeExpand = false } = handlers;

  const buttons = [];



  if (includeExpand && typeof onExpand === "function") {

    buttons.push({

      name: "Expand",

      icon: { svg: MODEBAR_ICON_EXPAND_SVG },

      click: onExpand,

    });

  }



  if (typeof onCsv === "function") {

    buttons.push({

      name: "Download CSV",

      icon: { svg: MODEBAR_ICON_CSV_SVG },

      click: onCsv,

    });

  }



  if (typeof onPng === "function") {

    buttons.push({

      name: "Download plot as a png",

      icon: { svg: MODEBAR_ICON_CAMERA_SVG },

      click: onPng,

    });

  }



  if (buttons.length === 0) {

    return {

      responsive: true,

      displaylogo: false,

      displayModeBar: false,

    };

  }



  return {

    responsive: true,

    displaylogo: false,

    displayModeBar: true,

    modeBarButtonsToRemove: MODEBAR_BUTTONS_TO_REMOVE,

    modeBarButtonsToAdd: buttons,

  };

}



/** After Plotly.newPlot — ensure modebar groups are visible (charts.css hides group 2 in modals). */

export function ensurePlotlyModebarVisible(chartEl) {

  if (!chartEl) {

    return;

  }

  const root = chartEl.classList?.contains("js-plotly-plot")

    ? chartEl

    : chartEl.querySelector?.(".js-plotly-plot");

  if (!root) {

    return;

  }

  const modebar = root.querySelector(".modebar");

  if (!modebar) {

    return;

  }

  modebar.style.display = "flex";

  modebar.style.visibility = "visible";

  modebar.style.opacity = "1";

  modebar.querySelectorAll(".modebar-group").forEach((group) => {

    const hasButtons = group.querySelector(".modebar-btn");

    if (hasButtons) {

      group.style.display = "flex";

    }

  });

}


